import React from 'react';
import { Button } from 'fronton-react';
import { cn } from 'utils/classnames';
import { ShortArrow } from 'common/icons/short-arrow';
import { css } from 'linaria';
import { ButtonLabeled, Props } from './carousel-control.types';
import { buttonStyle } from './carousel-control.styles';

export const CarouselControl: React.FC<Props> = ({
  direction = 'left',
  onClick,
  rounded,
  iconOnly,
  label,
  iconSize,
  className,
  ...props
}) => {
  return (
    <Button
      className={cn(className, buttonStyle, direction === 'left' ? 'left' : 'right')}
      kind="regular"
      {...(rounded && { rounded: true })}
      {...(iconOnly && { iconOnly: true })}
      label={label || ''}
      onClick={onClick}
      {...(props as ButtonLabeled)}
    >
      <ShortArrow className={arrowStyle} direction={direction} strokeWidth={1} />
    </Button>
  );
};

export const arrowStyle = css`
  width: var(--space-200);
  height: var(--space-200);
`;
